module.exports = __webpack_public_path__ + "assets/img/4.66cbe6df.jpg";